import { useEffect, useState } from "react";
import axios from "../../utils/axiosInstance";
import Textarea from "../../components/edittext/textArea/Textarea";
import BasicInput from "../../components/edittext/basicInput/basicInput";
import FileInput from "../../components/edittext/fileInput/fileInput";

import ProfilePicture from "../../components/Image/ProfilePicture";
import DocumentPreview from "../../components/DocumentPreview";

const Profile = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [editMode, setEditMode] = useState(false);
  const [form, setForm] = useState({});
  const [docFile, setDocFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [image, setImage] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    fetchProfile();
  }, []);

  const fetchProfile = async () => {
    try {
      setLoading(true);
      const res = await axios.get("/users/me");

      setUser(res.data.data);
      // console.log("user profile", res.data.data);
      setForm(res.data.data); // shallow copy; we'll access nested fields below
    } catch (err) {
      console.error("fetch profile", err);
    } finally {
      setLoading(false);
    }
  };
  const handleProfileImageUpload = async (file) => {
    try {
      const fd = new FormData();
      fd.append("image", file);

      const res = await axios.post("/users/me/upload-avatar", fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      console.log("uppro", res.data.url);
      // آپدیت کاربر با عکس جدید
      setUser((prev) => {
        const isSeller = prev.role === "seller" || prev.vendorRequest;
        return isSeller
          ? {
              ...prev,
              sellerProfile: {
                ...prev.sellerProfile,
                avatar: res.data.url,
              },
            }
          : {
              ...prev,
              profile: {
                ...prev.profile,
                avatar: res.data.url,
              },
            };
      });
    } catch (err) {
      console.error("upload profile image", err);
      alert("خطا در آپلود عکس پروفایل");
    }
  };

  const onChange = (path, value) => {
    // helper to set nested fields like 'profile.phone' or 'sellerProfile.companyName'
    const out = { ...form };
    const parts = path.split(".");
    let cur = out;
    for (let i = 0; i < parts.length - 1; i++) {
      if (!cur[parts[i]]) cur[parts[i]] = {};
      cur = cur[parts[i]];
    }
    cur[parts[parts.length - 1]] = value;
    setForm(out);
  };

  const handleSave = async () => {
    try {
      setLoading(true);
      const payload = {};
      if (user.role === "seller" || user.vendorRequest) {
        payload.sellerProfile = form.sellerProfile || {};
      } else {
        payload.profile = form.profile || {};
      }
      if (form.name) payload.name = form.name;
      if (form.phone) payload.phone = form.phone;

      const res = await axios.put("/users/me", payload);
      setUser(res.data.data);
      setEditMode(false);
    } catch (err) {
      console.error("save profile", err);
      alert("خطا در ذخیره");
    } finally {
      setLoading(false);
    }
  };

  const handleDocSelect = (e) => {
    setDocFile(e.target.files[0]);
  };

  const handleUploadDoc = async () => {
    if (!docFile) {
      alert("یک فایل انتخاب کنید");
      return;
    }
    try {
      setUploading(true);
      const fd = new FormData();
      fd.append("doc", docFile);
      const res = await axios.post("/users/me/vendor-docs", fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      // اضافه کردن به لیست محلی
      console.log("upload doc", res.data.doc);
      setUser((prev) => ({
        ...prev,
        vendorDocs: [...(prev.vendorDocs || []), res.data.doc],
      }));
      setDocFile(null);
      alert("آپلود شد — منتظر تایید ادمین باشید");
    } catch (err) {
      console.error("upload doc", err);
      alert("خطا در آپلود");
    } finally {
      setUploading(false);
    }
  };
  const handleUpload = async () => {
    if (!selectedFile) return;
    const formData = new FormData();
    formData.append("image", selectedFile); // فایلی که کاربر انتخاب کرده

    axios
      .post("/products/upload-image", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        console.log("Image uploaded:", res.data);
        // setImages((prev) => [...prev, res.data.url]);
      })
      .catch((err) => {
        console.error("Upload error:", err);
      });
  };

  if (loading) return <div className="p-3">Loading...</div>;
  if (!user) return <div className="p-3">User not found.</div>;

  const isSeller = user.role === "seller" || user.vendorRequest;

  return (
    <div className="container my-4">
      <div className="row">
        <div className="col-12 col-md-8 order-1 order-md-0">
          <div className="card mb-3">
            <div className="card-body">
              <h5>Profile</h5>
              <div className="mb-3 mt-3">
                <BasicInput
                  bsize="1"
                  bcolor="primary"
                  margin="2"
                  bgcolor="white"
                  textcolor="black"
                  scolor="primary"
                  text="Name"
                  value={form.name || ""}
                  onChange={(value) => onChange("name", value)}
                  disabled={!editMode}
                />
              </div>

              {!isSeller && (
                <>
                  <h6>Customer Profile</h6>
                  <div className="mb-3">
                    <BasicInput
                      bsize="1"
                      bcolor="primary"
                      margin="2"
                      bgcolor="white"
                      textcolor="black"
                      scolor="primary"
                      text="Phone"
                      value={form.phone || ""}
                      onChange={(value) => onChange("phone", value)}
                      disabled={!editMode}
                    />
                  </div>
                  <div className="mb-3">
                    <Textarea
                      margin="2"
                      bcolor="primary"
                      bgcolor="white"
                      textcolor="black"
                      text="Address"
                      value={(form.profile && form.profile.address) || ""}
                      onChange={(value) => onChange("profile.address", value)}
                      disabled={!editMode}
                    />
                  </div>
                </>
              )}

              {isSeller && (
                <>
                  <h6>Seller Profile</h6>
                  <div className="mb-3 mt-3">
                    <BasicInput
                      bsize="1"
                      bcolor="primary"
                      margin="2"
                      bgcolor="white"
                      textcolor="black"
                      scolor="primary"
                      text="Company Name"
                      value={
                        (form.sellerProfile &&
                          form.sellerProfile.companyName) ||
                        ""
                      }
                      onChange={(value) =>
                        onChange("sellerProfile.companyName", value)
                      }
                      disabled={!editMode}
                    />
                  </div>
                  <div className="mb-3">
                    <BasicInput
                      bsize="1"
                      bcolor="primary"
                      margin="2"
                      bgcolor="white"
                      textcolor="black"
                      scolor="primary"
                      text="National/Company ID"
                      value={
                        (form.sellerProfile && form.sellerProfile.nationalId) ||
                        ""
                      }
                      onChange={(value) =>
                        onChange("sellerProfile.nationalId", value)
                      }
                      disabled={!editMode}
                    />
                  </div>
                  <div className="mb-3">
                    <BasicInput
                      bsize="1"
                      bcolor="primary"
                      margin="2"
                      bgcolor="white"
                      textcolor="black"
                      scolor="primary"
                      text="Phone"
                      value={form.phone || ""}
                      onChange={(value) => onChange("phone", value)}
                      disabled={!editMode}
                    />
                  </div>
                  {/* <div className="mb-2">
                    <Textarea
                      margin="2"
                      bcolor="primary"
                      bgcolor="white"
                      textcolor="black"
                      text="Address"
                      value={
                        (form.sellerProfile && form.sellerProfile.address) || ""
                      }
                      onChange={(value) =>
                        onChange("sellerProfile.address", value)
                      }
                      disabled={!editMode}
                    />
                  </div> */}
                  <div className="mb-3">
                    <Textarea
                      margin="2"
                      bcolor="primary"
                      bgcolor="white"
                      textcolor="black"
                      text="Description"
                      value={
                        (form.sellerProfile &&
                          form.sellerProfile.description) ||
                        ""
                      }
                      onChange={(value) =>
                        onChange("sellerProfile.description", value)
                      }
                      disabled={!editMode}
                    />
                  </div>
                </>
              )}

              <div className="mt-3">
                {!editMode ? (
                  <button
                    className="btn btn-primary"
                    onClick={() => setEditMode(true)}
                  >
                    Edit
                  </button>
                ) : (
                  <>
                    <button
                      className="btn btn-success me-2"
                      onClick={handleSave}
                    >
                      Save
                    </button>
                    <button
                      className="btn btn-secondary"
                      onClick={() => {
                        setEditMode(false);
                        setForm(user);
                      }}
                    >
                      Cancel
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>

          {/* vendor docs list */}
          {isSeller && (
            <div className="card mb-3">
              <div className="card-body">
                <h5>Seller documents</h5>
                <p>
                  Application status:{" "}
                  {user.vendorRequest
                    ? "Requested (Pending Approval)"
                    : "Not Registered"}
                </p>
                <div className="mb-2">
                  <FileInput
                    bsize="2"
                    bcolor="primary"
                    margin="2"
                    bgcolor="white"
                    textcolor="black"
                    handleFileChange={handleDocSelect}
                    handleUpload={handleUploadDoc}
                  />
                </div>

                <div>
                  <DocumentPreview docs={user.vendorDocs || []} />

                  {/* {(user.vendorDocs || []).map((d, i) => (
                    <div key={i} className="mb-2">
                      <a
                        href={`${process.env.REACT_APP_API_BASE_URL}${d.url}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {d.filename}
                      </a>
                    
                    </div>
                  ))} */}
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="col-12 col-md-4 order-0 order-md-1 mb-2">
          <div className="card">
            <div className="card-body">
              <ProfilePicture
                image={
                  isSeller ? user.sellerProfile?.avatar : user.profile?.avatar
                }
                onUpload={handleProfileImageUpload}
              />

              <h6>Account Information</h6>
              <p>
                <strong>Email:</strong> {user.email}
              </p>
              <p>
                <strong>Role:</strong> {user.role}
              </p>
              <h6 className="fw-bold">
                Status:
                <span
                  className={`m-2 pb-2 badge ${
                    user.status === "approved"
                      ? "bg-success"
                      : user.status === "pending"
                      ? "bg-warning"
                      : "bg-danger"
                  }`}
                >
                  {user.status}
                </span>
              </h6>

              <p>
                <strong>Member since:</strong>{" "}
                {new Date(user.createdAt).toLocaleDateString()}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;

